export default "https://npm-assets.fiverrcdn.com/assets/@fiverr/search_perseus/apps/Ebook_Writing_fr-FR.065a23a.vtt";